import { postFetch } from '../fetch';
import { apiConfig } from '../config';

interface DiagnosticAssignedRequest {
    diagnosticId: string;
    courseLessonLinkId: number;
    courseId: number;
}

interface DiagnosticAssignedResponse {
    diagnostic_id: string,
    course_lesson_link_id: number,
    course_id: number,
    id: string
}

export function postDiagnosticAssigned(
    request: DiagnosticAssignedRequest
): Promise<DiagnosticAssignedResponse> {
    const { apiPostDiagnosticAssigned } = apiConfig.getStaticUrls();

    return postFetch(apiPostDiagnosticAssigned, request);
}
